import { useTranslation } from 'react-i18next'
import BottomSheet from '../mobile/BottomSheet'
import MaterialIcon from '../ui/MaterialIcon'
import { KILO } from '../../constants/KILO_THEME'

type HealthLegalSheetProps = {
  open: boolean
  onClose: () => void
  screeningExclusions: string[]
  onOpenDisclaimer: () => void
  onOpenPrivacy: () => void
  onOpenScreening: () => void
}

const HealthLegalSheet = ({
  open,
  onClose,
  screeningExclusions,
  onOpenDisclaimer,
  onOpenPrivacy,
  onOpenScreening,
}: HealthLegalSheetProps) => {
  const { t } = useTranslation()

  return (
    <BottomSheet open={open} onClose={onClose} title={t('profile.healthLegal')} variant="dark">
      <div className="space-y-2">
        <button type="button" className={KILO.rowBtn} onClick={onOpenDisclaimer}>
          {t('profile.wellnessDisclaimer')}
          <MaterialIcon name="chevron_right" size="sm" />
        </button>
        <button type="button" className={KILO.rowBtn} onClick={onOpenPrivacy}>
          {t('profile.privacy')}
          <MaterialIcon name="chevron_right" size="sm" />
        </button>
        <button type="button" className={`${KILO.rowBtn} text-left`} onClick={onOpenScreening}>
          <span>
            {t('profile.healthScreening')}
            {screeningExclusions.length > 0 ? (
              <span className="mt-0.5 block text-xs text-amber-400">{t('profile.screeningReview')}</span>
            ) : null}
          </span>
          <MaterialIcon name="chevron_right" size="sm" />
        </button>
        <a
          href="https://kilo.app/legal/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className={KILO.rowBtn}
        >
          {t('profile.privacyPolicy')}
          <MaterialIcon name="open_in_new" size="sm" />
        </a>
        <a
          href="https://kilo.app/legal/terms"
          target="_blank"
          rel="noopener noreferrer"
          className={KILO.rowBtn}
        >
          {t('profile.termsOfService')}
          <MaterialIcon name="open_in_new" size="sm" />
        </a>
      </div>
    </BottomSheet>
  )
}

export default HealthLegalSheet
